<script lang="ts">
    import type { ToolOptions } from "$lib/wasm/interaction";

    export let options: ToolOptions;
    export let update: (name: string) => void;

    function toReadable(name: string): string {
        return name.charAt(0).toUpperCase() + name.replaceAll("_", " ").slice(1);
    }
</script>

<!----------------------------------------------------------------------------->

<ul>
    {#each [...options.entries()].sort() as [name, option]}
        <li><label>
                <span>
                    {toReadable(name)}
                </span>
            {#if option.type === "Number"}
                <input
                    type="number"
                    bind:value={option.value}
                    min={option.min}
                    max={option.max}
                    on:change={() => update(name)}
                />
            {:else if option.type === "Bool"}
                <input
                    type="checkbox"
                    bind:checked={option.value}
                    on:change={() => update(name)}
                />
            {/if}

        </label></li>
    {/each}
</ul>

<!----------------------------------------------------------------------------->

<style>
    ul {
        all: unset;
        display: grid;
        grid-template-columns: max-content 1fr;
        gap: 0.5em;
    }

    li {
        list-style: none;
        display: grid;
        grid-template-columns: subgrid;
        grid-column: 1 / -1;
    }

    label {
        display: grid;
        grid-template-columns: subgrid;
        grid-column: 1 / -1;
        align-items: center;
    }
</style>
